import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
const PROCESS_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/8763dee3-a359-4b9c-824c-0fb3a5a587ee.jpg';
export function Method() {
  return <section className="w-full bg-moss text-cream" data-id="element-92" data-mp="c2rpr0wynnil">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-9 px-5 py-12 sm:gap-12 sm:px-6 sm:py-16 lg:grid-cols-2 lg:gap-16 lg:py-24" data-id="element-93" data-mp="h1b9cuo30n7s">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-94" data-mp="3fgubvmok0n8m">
          <SectionLabel tone="light" data-id="element-95" data-mp="3u7uw0oyny5kl">La revelación</SectionLabel>
          <h2 className="font-display text-[1.6rem] leading-tight sm:text-4xl lg:text-[2.75rem]" data-id="element-96" data-mp="3u9efeofm8wql">
            Presentamos el <em className="italic" data-id="element-97" data-mp="31r0n14d1u2yw">Método Maestro Jabonero</em>
          </h2>
          <p className="mt-5 font-sans text-[15px] leading-relaxed text-cream/80 sm:mt-6 sm:text-base" data-id="element-98" data-mp="31oxnntq0axhi">
            He destilado años de pruebas y errores en una guía digital práctica
            que elimina la confusión. Este es el mapa exacto para que aprendas la
            técnica de vertido y glicerina de forma segura, logrando
            terminaciones profesionales desde tu primer jabón.
          </p>
          <p className="mt-5 font-display text-lg italic leading-relaxed text-cream sm:text-2xl" data-id="element-99" data-mp="6ox16xef1m2w">
            Aprendé a tu ritmo, desconectate del estrés diario y convertí tu
            pasión en un negocio aromático.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} src={PROCESS_IMAGE} alt="Manos vertiendo base de glicerina derretida en un molde de madera en una cocina" className="aspect-[4/3] w-full rounded-[1.5rem] object-cover shadow-soft sm:aspect-auto sm:rounded-[2rem]" data-id="element-100" data-mp="3swwq2c5ns08u" />
      </div>
    </section>;
}